var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value " },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择", disabled: _vm.id != null },
                  model: {
                    value: _vm.servcAccClaimInfo.servcTypeId,
                    callback: function($$v) {
                      _vm.$set(_vm.servcAccClaimInfo, "servcTypeId", $$v)
                    },
                    expression: "servcAccClaimInfo.servcTypeId"
                  }
                },
                _vm._l(_vm.tableState, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.text, value: item.value }
                  })
                })
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("分类信息")]),
        _vm._v(" "),
        _vm.id == null
          ? _c(
              "a",
              {
                staticClass: "swb-btn-link",
                on: {
                  click: function($event) {
                    _vm.selectCatInfo()
                  }
                }
              },
              [_vm._v("选择")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("table", { staticClass: "custom-tbl" }, [
        _vm._m(2),
        _vm._v(" "),
        _c(
          "tbody",
          { staticClass: "body" },
          [
            _vm._l(_vm.catList, function(item, index) {
              return _vm.catList != null && _vm.catList.length > 0
                ? _c("tr", { staticClass: "row" }, [
                    _c("td", { staticStyle: { "text-align": "left" } }, [
                      _c("span", [_vm._v(_vm._s(item.catName))])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      item.level == 1 ? _c("span", [_vm._v("一级")]) : _vm._e(),
                      _vm._v(" "),
                      item.level == 2 ? _c("span", [_vm._v("二级")]) : _vm._e(),
                      _vm._v(" "),
                      item.level == 3 ? _c("span", [_vm._v("三级")]) : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm.id == null
                        ? _c(
                            "span",
                            {
                              staticClass: "swb-btn swb-btn-link",
                              on: {
                                click: function($event) {
                                  _vm.removeCatInfo(index)
                                }
                              }
                            },
                            [_vm._v("移除")]
                          )
                        : _vm._e()
                    ])
                  ])
                : _vm._e()
            }),
            _vm._v(" "),
            _vm.catList == null || _vm.catList.length <= 0
              ? _c("tr", { staticClass: "row" }, [_vm._m(3)])
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "servcAccClaimInfo",
          attrs: { model: _vm.servcAccClaimInfo, rules: _vm.servcAccClaimRules }
        },
        [
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("配件名称")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value " },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "name" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x ",
                        model: {
                          value: _vm.servcAccClaimInfo.name,
                          callback: function($$v) {
                            _vm.$set(_vm.servcAccClaimInfo, "name", $$v)
                          },
                          expression: "servcAccClaimInfo.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("规格")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "spec" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x ",
                        model: {
                          value: _vm.servcAccClaimInfo.spec,
                          callback: function($$v) {
                            _vm.$set(_vm.servcAccClaimInfo, "spec", $$v)
                          },
                          expression: "servcAccClaimInfo.spec"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("价格下限")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value " },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "price" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x ",
                        attrs: { type: "number" },
                        model: {
                          value: _vm.servcAccClaimInfo.price,
                          callback: function($$v) {
                            _vm.$set(_vm.servcAccClaimInfo, "price", $$v)
                          },
                          expression: "servcAccClaimInfo.price"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-tips" }, [_vm._v("元")])
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("价格上限")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value " },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "price2" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x ",
                        attrs: { type: "number" },
                        model: {
                          value: _vm.servcAccClaimInfo.price2,
                          callback: function($$v) {
                            _vm.$set(_vm.servcAccClaimInfo, "price2", $$v)
                          },
                          expression: "servcAccClaimInfo.price2"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-tips" }, [_vm._v("元")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-tip error" }, [
                    _vm._v("价格上、下限为零时为不要求")
                  ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("来源要求")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value " },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "srcFlag" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.servcAccClaimInfo.srcFlag,
                            callback: function($$v) {
                              _vm.$set(_vm.servcAccClaimInfo, "srcFlag", $$v)
                            },
                            expression: "servcAccClaimInfo.srcFlag"
                          }
                        },
                        [
                          _c("el-option", {
                            key: -1,
                            attrs: { label: "无要求", value: -1 }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            key: 0,
                            attrs: { label: "服务商", value: 0 }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            key: 2,
                            attrs: { label: "授权商", value: 2 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("备注")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "memo" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x",
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入备注信息"
                        },
                        model: {
                          value: _vm.servcAccClaimInfo.memo,
                          callback: function($$v) {
                            _vm.$set(_vm.servcAccClaimInfo, "memo", $$v)
                          },
                          expression: "servcAccClaimInfo.memo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("服务类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("服务类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", { staticStyle: { "text-align": "left" } }, [_vm._v("分类")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "120" } }, [_vm._v("分类级别")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "80" } }, [_vm._v("操作")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: { "text-align": "center", "line-height": "40px" },
        attrs: { colspan: "3" }
      },
      [_c("span", [_vm._v("暂无数据...")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("配件要求")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b08b79a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b08b79a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/servcClaim/ServcAccClaimSave.vue
// module id = 2010
// module chunks = 1